import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { useCurrentWidth } from '../../utils/resize';

import './SeeYouSoon.scss';

const SeeYouSoon = (props) => {
  const location = useLocation();
  localStorage.removeItem('link_url');
  localStorage.removeItem('link_url_user');
  localStorage.removeItem('isMember');
  localStorage.removeItem('name');
  localStorage.removeItem('last_name');

  return (
    <div className='seeYouContainer'>
      <div className='slideBodySeeYou'>
        <div className='title-logo-container'>
          <h2>À bientôt sur</h2>
          <img
            className='humoon_logo'
            alt='Humoon logo'
            src={require('../../assets/images/humoonLogo.png')} />
        </div>
        {!location.state && (
          <p>Merci encore d’avoir pris le temps d’aider {props.receiverName}, nous espérons te revoir très bientôt ;)</p>
        )}

        <div className='motorbikeContainer'>
          <img
            className='motorbike'
            alt='Motorbike'
            src={useCurrentWidth() >= 416 ? require('../../assets/images/motorbike.png') : 
              require('../../assets/images/smallMotorbike.png')} />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    receiverName: state.feedback.receiverName
  }
}

export default connect(mapStateToProps)(SeeYouSoon);